import { render, staticRenderFns } from "./type-ranking.vue?vue&type=template&id=2df0ee26&"
import script from "./type-ranking.vue?vue&type=script&lang=js&"
export * from "./type-ranking.vue?vue&type=script&lang=js&"
import style0 from "./type-ranking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports